import useIsContainerBeyondBreakpoint from '@/hooks/useIsContainerBeyondBreakpoint';
import { useMeasure } from '@payaca/hooks';
import { CSSProperties, FC } from 'react';
import ScheduleDispatchFilters from '../scheduleDispatchFilters/ScheduleDispatchFilters';
import { ScheduleDispatchMain } from './ScheduleDispatchMain';

export const ScheduleWithStickyControls: FC = () => {
  const isDesktop = useIsContainerBeyondBreakpoint('md', {
    container: 'document',
  });
  const [controlsRef, { height: controlsHeight }] =
    useMeasure<HTMLDivElement>();

  const style: CSSProperties & Record<'--schedule-sticky-top', string> = {
    '--schedule-sticky-top': `${controlsHeight}px`,
  };

  return (
    <div className="flex grow flex-col" style={isDesktop ? style : undefined}>
      <div ref={controlsRef} className="md:sticky md:top-0 z-sticky bg-white">
        <div className="py-4">
          <ScheduleDispatchFilters />
        </div>
      </div>
      <ScheduleDispatchMain />
    </div>
  );
};
